<!-- <app-navbar></app-navbar> -->
<router-outlet></router-outlet>

<!--spinner-->
<ngx-spinner size="medium" type="triangle-skew-spin" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>